// extracted by mini-css-extract-plugin
export default {"wrapper":"gallery_wrapper__Pzms1"};